<template>
  <div id="why-choose-us">
    <v-card class="section-card">
      <v-card-title :class="{ 'mobile-card-title': isMobile }">{{ $t('whyChooseUsTitle') }}</v-card-title>
      <p :class="{ 'mobile-card-subheading': isMobile }">{{ $t('whyChooseUsSubheading') }}</p>

      <v-card-text style="padding: 0">
        <div class="reasons-grid">
          <div class="reason-item">
            <div class="reason-icon">
              <v-icon size="36" color="white">mdi-earth</v-icon>
            </div>
            <h3 class="reason-title">{{ $t('whyGlobalTitle') }}</h3>
            <p class="reason-text">{{ $t('whyGlobalText') }}</p>
          </div>

          <div class="reason-item">
            <div class="reason-icon">
              <v-icon size="36" color="white">mdi-clock-fast</v-icon>
            </div>
            <h3 class="reason-title">{{ $t('whyAgileTitle') }}</h3>
            <p class="reason-text">{{ $t('whyAgileText') }}</p>
          </div>

          <div class="reason-item">
            <div class="reason-icon">
              <v-icon size="36" color="white">mdi-handshake-outline</v-icon>
            </div>
            <h3 class="reason-title">{{ $t('whyPartnerTitle') }}</h3>
            <p class="reason-text">{{ $t('whyPartnerText') }}</p>
          </div>

          <div class="reason-item">
            <div class="reason-icon">
              <v-icon size="36" color="white">mdi-chart-line</v-icon>
            </div>
            <h3 class="reason-title">{{ $t('whyResultsTitle') }}</h3>
            <p class="reason-text">{{ $t('whyResultsText') }}</p>
          </div>

          <div class="reason-item">
            <div class="reason-icon">
              <v-icon size="36" color="white">mdi-cog-outline</v-icon>
            </div>
            <h3 class="reason-title">{{ $t('whyTailoredTitle') }}</h3>
            <p class="reason-text">{{ $t('whyTailoredText') }}</p>
          </div>

          <div class="reason-item">
            <div class="reason-icon">
              <v-icon size="36" color="white">mdi-lock-check-outline</v-icon>
            </div>
            <h3 class="reason-title">{{ $t('whySecurityTitle') }}</h3>
            <p class="reason-text">{{ $t('whySecurityText') }}</p>
          </div>
        </div>

        <div class="stats-row">
          <div class="stat-item">
            <span class="stat-number">50+</span>
            <span class="stat-label">{{ $t('whyStatClients') }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">7</span>
            <span class="stat-label">{{ $t('whyStatCountries') }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">100+</span>
            <span class="stat-label">{{ $t('whyStatProjects') }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">9.2/10</span>
            <span class="stat-label">{{ $t('whyStatSatisfaction') }}</span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "WhyChooseUs",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.section-card {
  margin: 10px !important;
  padding: 20px !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
  background: linear-gradient(90deg, #03000f, #3533cd) !important;
  color: #ffffff !important;
  border-radius: 25px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.reasons-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 3rem;
}

@media (max-width: 768px) {
  .reasons-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

.reason-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.reason-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.25rem;
}

.reason-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
}

.reason-text {
  font-size: 0.95rem;
  line-height: 1.5;
  color: white;
  opacity: 0.9;
}

.stats-row {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 2rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  padding: 2rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.25rem;
}

.stat-number {
  font-size: 2.2rem;
  font-weight: 800;
  color: #f3d129;
}

.stat-label {
  font-size: 0.95rem;
  color: white;
  opacity: 0.85;
}

.mobile-card-title {
  font-size: 1.5rem;
}

.mobile-card-subheading {
  font-size: 1rem;
}
</style>
